import { z } from "zod";

import {
  rowAchievementsTypeSchema,
  rowEnrolmentsAchievementsTypeSchema,
  updateEnrolmentsAchievementsTypeSchema,
} from "@libs/schemas";

export const enrolmentAchievementSchema = z.array(
  z
    .object({
      achievement: rowAchievementsTypeSchema.pick({ id: true, name: true }),
    })
    .merge(
      rowEnrolmentsAchievementsTypeSchema
        .pick({
          id: true,
          grade: true,
          achievement_id: true,
        })
        .extend({
          // Coerce grade to number if it's a string
          grade: z.preprocess(
            val =>
              val === ""
                ? undefined
                : typeof val === "string"
                  ? Number(val)
                  : val,
            z.number().optional(),
          ),
        }),
    ),
);

export const updateEnrolmentAchievementsSchema = z.array(
  updateEnrolmentsAchievementsTypeSchema.omit({
    updated_at: true,
    created_at: true,
    enrolment_id: true,
    achievement_id: true,
  }),
);

export type UpdateEnrolmentAchievementsType = z.infer<
  typeof updateEnrolmentAchievementsSchema
>;
